import { createFileRoute } from '@tanstack/react-router';
import { TransactionalNewRouteView } from '@/pages/workspaces/transactional/new/routing';
import { LastWorkspaceResolver } from './-components';

/**
 * The create-message page. The `transactional_` (trailing underscore) segment keeps it out of the
 * `transactional.tsx` list route, which renders no outlet.
 */
function TransactionalNewRoute() {
  return (
    <LastWorkspaceResolver>
      <TransactionalNewRouteView />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/transactional_/new')({
  component: TransactionalNewRoute,
});
